// Datos de la pagina 404,

export const data_404Page = {
  mainTextColor: "#484554",
  buttonBgColor: "#484554",
  buttonTextColor: "white",
};
